import React from 'react';
import Image from 'next/image';
import { useTranslation } from 'react-i18next';
import {
  AgencyInfoContent,
  AgencyInfoLink,
  AgencyInfoLogo,
  AgencyInfoText,
  AgencyInfoTitle
} from './styled';

interface AgencyInfoSectionProps {
  path: string;
  name?: string;
  imageUrl: string;
}

export const AgencyInfoSection: React.FC<AgencyInfoSectionProps> = ({
  path,
  name,
  imageUrl
}) => {
  const { t } = useTranslation();

  return (
    <AgencyInfoLink href={path} data-cy="agency-info">
      <AgencyInfoContent>
        <AgencyInfoTitle tag="title_4_new">{name}</AgencyInfoTitle>
        <AgencyInfoText tag="body_2">
          {t('pages.current_item.owner_info.agency')}
        </AgencyInfoText>
      </AgencyInfoContent>

      <AgencyInfoLogo>
        <Image src={imageUrl} alt="photo" width={55} height={55} />
      </AgencyInfoLogo>
    </AgencyInfoLink>
  );
};
